import { useState } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import languages from 'constants/languages';

export default function LangSelectorDropdown({ defaultLang = 'en', onChange }) {
	const [lang, setLang] = useState(defaultLang);

	const handleChange = (event) => {
		setLang(event.target.value);
		if (onChange) onChange(event.target.value);
	};

	return (
		<Box sx={{ minWidth: 120 }}>
			<FormControl fullWidth>
				{/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
				<Select
					labelId="demo-simple-select-label"
					id="demo-simple-select"
					value={lang}
					onChange={handleChange}
					sx={{
						'& .MuiOutlinedInput-notchedOutline': {
							top: 0,
							legend: {
								display: 'none',
							},
						},
						maxHeight: '40px',
						width: '120px',
					}}
					MenuProps={{
						disablePortal: true, // ensures dropdown stays within DOM hierarchy
						PaperProps: {
							sx: {
								mt: 1, // adds margin so it shows below the select box
								zIndex: 9999,
								maxHeight: '200px',
							},
						},
						anchorOrigin: {
							vertical: 'bottom',
							horizontal: 'left',
						},
						transformOrigin: {
							vertical: 'top',
							horizontal: 'left',
						},
					}}
				>
					{languages.map((lang, index) => {
						return (
							<MenuItem key={index} value={lang.code}>
								{/* {lang.code.split('-')[0]?.toUpperCase()} */}
								{lang.name}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
}
